
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"32","height":"32","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#zvv8iqaqfa)"}},[_c('path',{attrs:{"d":"M16 0a16 16 0 100 32 16 16 0 000-32zm0 25.6a1.6 1.6 0 110-3.199 1.6 1.6 0 010 3.199zm1.6-8.256V19.2a1.6 1.6 0 01-3.2 0V16a1.6 1.6 0 011.6-1.6 2.4 2.4 0 10-2.4-2.4 1.6 1.6 0 01-3.2 0 5.6 5.6 0 117.2 5.344z","fill":"#000"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"zvv8iqaqfa"}},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h32v32H0z"}})])])])
          )
        }
      }
    